var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('h3',[_vm._v("Sensor List")]),_c('SimpleTable',{attrs:{"headers":_vm.getHeaders(),"items":_vm.items,"tableId":"DceId"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }